// https://vuex.vuejs.org/en/mutations.html

export default {
  setLoaded(state, b) {
    state.loaded = b;
  },
  setLangSeleccionado(state, v) {
    state.langSeleccionado = v;
  },
  setLangSeleccionadoDefecto(state) {
    state.langSeleccionado = state.langDefecto;
  },
  SET_BAR_IMAGE(state, payload) {
    state.barImage = payload
  },
  SET_DRAWER(state, payload) {
    state.drawer = payload
  },
  SET_SCRIM(state, payload) {
    state.barColor = payload
  },
  setHoraActual(state, i) {
    state.horaActual = i;
  },
  SET_TRADUCCIONES_DIALOG(state, b) {
    state.traduccionesDialog = b;
  },
  SET_TRADUCCIONES_OBJ(state, obj) {
    state.traduccionesObj = obj
  }

}
